module.exports = new __parcel__URL__("pig.2ba131ea.svg").toString();